import Chart1 from "components/Charts/Chart1"
import React, { useState } from "react"
import {
  Card,
  CardBody,
  Col,
  Row,
  CardHeader,
  Button,
  Collapse,
  Spinner,
  Table,
} from "reactstrap"
import { useSelector } from "react-redux"
import Chart2 from "components/Charts/Chart2"
import { isNaN } from "lodash"

import MonitorStockFilter from "./MonitorStockFilter"
import MonitorStockItemList from "./MonitorStockItemList"

const MonitorStock = ({
  onSubmit,
  onCategoryChange,
  provStock,
  onAdvancedSearchHandler,
  onProviderStockExport,
  provData,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const [searchDate, setSearchDate] = useState({
    fromDate: null,
    toDate: null,
  })

  const [category, setCategory] = useState({
    value: 10,
    label: "Family Planning Commodities",
  })

  const exportStatus = useSelector(
    state => state.monitorReports.monitorInventoyExport
  )

  let data = []
  if (provStock) {
    data = provStock?.map(stock => {
      const items = stock.item_name
      const in_qty = !isNaN(
        parseInt(stock.provider_ins_sum_first_in_qty_per_ip)
      )
        ? parseInt(stock.provider_ins_sum_first_in_qty_per_ip)
        : 0

      const out_qty = !isNaN(parseInt(stock.provider_outs_sum_out_quantity))
        ? parseInt(stock.provider_outs_sum_out_quantity)
        : 0
      const balance = in_qty - out_qty
      return { items, in_qty, out_qty, balance }
    })
  }

  const loading = useSelector(
    state => state.monitorDashboard.monitorStock.loading
  )

  const getSearchData = values => {
    setSearchDate({
      fromDate: values.from ? values.from : null,
      toDate: values.to ? values.to : null,
      providerIP: values.providerIP ? values.providerIP : null,
      providerUser: values.providerUser ? values.providerUser : null,
    })
    values.Categories
      ? setCategory(values.Categories)
      : setCategory({
          value: 10,
          label: "Family Planning Commodities",
        })
  }

  return (
    <CardBody>
      <Card>
        <CardHeader>
          <Row>
            <Col lg={6}>
              <Row>
                <Col
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <span style={{ fontSize: 20 }}>
                    Stock ( {category.label} )
                    {searchDate.fromDate && (
                      <p
                        style={{
                          fontSize: 15,
                          color: "#19ada1",
                          fontWeight: 700,
                        }}
                      >
                        ( {searchDate.fromDate} ) - ( {searchDate.toDate} )
                      </p>
                    )}
                  </span>
                  &nbsp;
                  {loading && (
                    <Spinner
                      className="ms-1"
                      style={{ padding: 7, marginTop: 5 }}
                      size="sm"
                      color="primary"
                    />
                  )}
                </Col>
              </Row>
            </Col>
            <Col lg={6} style={{ textAlign: "right" }}>
              <Button
                onClick={onProviderStockExport}
                className="btn btn-info "
                disabled={exportStatus?.loading}
              >
                {exportStatus?.loading ? "Please Wait..." : "Export"}
              </Button>
              &nbsp;
              <Button
                onClick={() => {
                  setIsOpen(!isOpen)
                }}
                className="btn btn-success "
              >
                {isOpen ? "Hide" : "Search"}
              </Button>
            </Col>
          </Row>
        </CardHeader>
        <CardBody>
          <Collapse isOpen={isOpen}>
            <MonitorStockFilter
              onCategoryChange={onCategoryChange}
              onSubmit={onSubmit}
              provStockLoading={loading}
              getSearchData={getSearchData}
              onAdvancedSearchHandler={onAdvancedSearchHandler}
            />
          </Collapse>
          <Chart2 data={data} />
          <MonitorStockItemList
            data={provStock}
            provData={provData}
            searchDate={searchDate}
          />
        </CardBody>
      </Card>
    </CardBody>
  )
}

export default MonitorStock
